import { Skeleton, Td, Tr } from '@chakra-ui/react';

interface TableRowsLoadingPlaceholderProps {
  dense?: boolean;
  small?: boolean;
}

const TableRowsLoadingPlaceholder: React.FC<TableRowsLoadingPlaceholderProps> = ({
  dense = false,
  small = false,
}) => {
  const cellPy = dense ? '19px' : '25px';

  return (
    <>
      {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map(i => (
        <Tr mt="16px" w="100%" key={i}>
          <Td w="20%" py={cellPy}>
            <div key={i}>
              <Skeleton key={i} height={'22px'} width={i % 2 === 0 ? '70%' : '60%'} />
            </div>
          </Td>

          {!small ? (
            <Td w="10%" py={cellPy}>
              <div key={i}>
                <Skeleton key={i} height={'22px'} width={i % 2 === 0 ? '80%' : '65%'} />
              </div>
            </Td>
          ) : null}

          <Td w="40%" py={cellPy}>
            <div key={i}>
              <Skeleton key={i} height={'22px'} width={i % 2 === 0 ? '70%' : '65%'} />
            </div>
          </Td>

          <Td w="10%" py={cellPy}>
            <div key={i}>
              <Skeleton key={i} height={'22px'} width="98%" />
            </div>
          </Td>

          <Td w="20%" py={cellPy}>
            <div key={i}>
              <Skeleton key={i} height={'22px'} width="98%" />
            </div>
          </Td>
        </Tr>
      ))}
    </>
  );
};

export default TableRowsLoadingPlaceholder;
